// src/components/UI/components/DropdownMenu/DropdownMenuSubMenu.tsx

import { Sub } from '@radix-ui/react-dropdown-menu';

export const DropdownMenuSubMenu = Sub;
DropdownMenuSubMenu.displayName = 'DropdownMenuSubMenu';
